

import React from 'react';
import ClassAssembly2B  from 'views/ClassAssembly2B';

const ClassAssemblyPage = () => {
    return <ClassAssembly2B />;
  };
  
  export default ClassAssemblyPage;